$(window).bind("load", function() {
    // Variables
    var testimonial_next = $('.testimonial__next');
    var testimonial_prev = $('.testimonial__prev');
    var testimonial_container = $('.testimonial__container');
    var testimonial = $('.testimonial__container .testimonial');

    // Add active class to first testimonial
    testimonial.first().addClass('testimonial--active');
    var testimonial_first_height = testimonial.first().outerHeight();
    var testimonial_last_height = testimonial.last().outerHeight();

    // Add height to container
    testimonial_container.css('min-height', testimonial_first_height);

    // Add next / prev if more than one slide
    if (testimonial.length > 1) {
        testimonial_next.show();
        testimonial_prev.show(); 
    }

    // Next
    testimonial_next.click(function () {
        var next = $('.testimonial--active').next();
        var next_height = $('.testimonial--active').next().outerHeight();

        if (next.length) {
            testimonial.removeClass('testimonial--active');
            next.addClass('testimonial--active');
            testimonial_container.css('min-height', next_height);
        } else {
            testimonial.removeClass('testimonial--active');
            testimonial.first().addClass('testimonial--active');
            testimonial_container.css('min-height', testimonial_first_height);
        }
    });

    // Prev
    testimonial_prev.click(function () {
        var prev = $('.testimonial--active').prev();
        var prev_height = $('.testimonial--active').prev().outerHeight();

        if (prev.length) {
            testimonial.removeClass('testimonial--active');
            prev.addClass('testimonial--active');
            testimonial_container.css('min-height', prev_height);
        } else {
            testimonial.removeClass('testimonial--active');
            testimonial.last().addClass('testimonial--active');
            testimonial_container.css('min-height', testimonial_last_height);
        }
    });
});